import { AlertTypes } from "../util/Constant.js";
import i18n from "../localization/i18n";
import ApiEngine from "../util/ApiEngine.js";
import { ApiUrl, ApiKey } from "../util/Constant";
import { numberWithCurrencyFormat, stringIsNullOrEmpty, formatApiMessage } from "../util/Util";
import { groupBy, map } from "lodash";
import {
    planOpen,
    planClose,
    planPromote,
    readOrchestratorState,
    MODAL_QUEUE_PROMOTE_DELAY_MS,
    MODAL_INIT_DELAY_MS,
} from "../util/modalOrchestrator";

export const _BIND_SETTING = "bindSetting";
export const _BIND_MEMBER = "bindMember";
export const _BIND_MEMBER_WALLET = "bindMemberWallet";
export const _BIND_MEMBER_WALLET_BALANCE = "bindMemberWalletBalance";
export const _BIND_GAMES = "bindGames";
export const _BIND_GAMES_RECOMMENDED = "bindGamesRecommended";
export const _BIND_GAMES_FEATURED = "bindGamesFeatured";
export const _BUSY = "busy";
export const _IDLE = "idle";
export const _API_CALLED = "setApiCalled";
export const _DOWNLINE_SEARCH = "setDownlineSearchTextCalled";
export const _DOWNLINE_QUERY = "setDownlineQueryCalled";
export const _REFERRAL_SEARCH = "setReferralSearchTextCalled";
export const _REFERRAL_QUERY = "setReferralQueryCalled";
export const _GAME_SEARCH = "setGameSearchTextCalled";
export const _GAME_QUERY = "setGameQueryCalled";
export const _SET_Y = "setY";
export const _SET_PAGESIZE = "setPageSize";
export const _SET_ACTIVE_TAB = "setActiveTab";
export const _SET_BOTTOM_TAB_INDEX = "setBottomTabIndex";
export const _SET_PAYMENT_LIST = "setPaymentList";
export const _SET_WALLET_INFO = "setWalletInfo";
export const _SET_OPEN_MENU = "setOpenMenu";
export const _SET_REPORT_OVERVIEW = "setReportOverview";
export const _SET_DOWNLINE = "setDownline";
export const _SET_BANNERS = "setBanners";
export const _SET_DEPOSIT_MODAL = "setDepositModal";
export const _SET_DEPOSIT_TAB = "setDepositTab";
export const _SET_LOGIN_MODAL = "setLoginModal";
export const _SET_GAME_LOBBY_MODAL = "setGameLobbyModal";
export const _SET_REGISTER_MODAL = "setRegisterModal";
export const _SET_PROVIDER = "setProvider";
export const _SET_LATEST_BETS = "setLatestBets";
export const _SET_RESET_PASSWORD = "setResetPassword";
export const _SET_DOWNLINE_MODAL = "setDownlineModal";
export const _SET_SHARE_REFERRAL_MODAL = "setShareReferralModal";
export const _BUSY_LOADING = "setBusyLoading";
export const _SET_PROFILE_MODAL = "setMyProfileModal";
export const _SET_SPIN_WHEEL_LIST_MODAL = "setSpinWheelListModal";
export const _SET_SPIN_WHEEL_REPORT_MODAL = "setSpinWheelReportModal";
export const _SET_SEO_CONTENT = "setSeoContent";
export const _SET_REPORT_OVERVIEW_MODAL = "setReportOverviewModal";
export const _SET_GAME_IFRAME_MODAL = "setGameIframeModal";
export const _SET_COMPLETE_INFO_MODAL = "setCompleteInfoModal";
export const _SET_REGISTER_SUCCESS_MODAL="setRegisterSuccessModal"
export const _SET_SHOW_ANNOUNCEMENT_MODAL="setShowAnnouncementModal"
export const _SET_DAILY_CHECKIN_MODAL = "setDailyCheckinModal";
export const _SET_DAILY_CHECKIN_EXIST = "setDailyCheckInExist";
export const _SET_REFERRAL_BONUS_MODAL = "setReferralBonusModal";
export const _SET_MUSIC_PLAYER_MODAL = "setMusicPlayerModal";
export const _IS_KEEPED_LOGIN = "userKeepLogin";
export const _BIND_HOT_GAMES = "bindHotGames";
export const _BIND_HOT_PROVIDERS = "bindHotProviders";
export const _SET_SPIN_WHEEL_LOADED = "setSpinWheelLoaded";
export const _SET_LANGUAGE_MODAL = "setLanguageModal";
export const _SET_DAILY_CHECK_IN_DETAILS = "setDailyCheckInDetails";
export const _SET_REWARD_TYPE = "setRewardType";
export const _SET_GAME_PROVIDER = "setGameProvider";
export const _FETCH_BANNERS_REQUEST = "fetchBannersRequest";
export const _FETCH_BANNERS_SUCCESS = "fetchBannersSuccess";
export const _FETCH_BANNERS_FAILURE = "fetchBannersFailure";
export const _SYNC_MODAL_ORCHESTRATOR = "syncModalOrchestrator";

export const _ALERT_TYPES = {
    SET_ALERT: "SetAlert",
    NONE: "AlertNone",
};

export const setY = (y) => {
    return (dispatch) => {
        dispatch({
            type: _SET_Y,
            y,
        });
    };
};

export const setBottomTabIndex = (bottomTabIndex) => {
    return (dispatch) => {
        dispatch({
            type: _SET_BOTTOM_TAB_INDEX,
            bottomTabIndex,
        });
    };
};

export const setBanners = (banners) => {
    return (dispatch) => {
        dispatch({
            type: _SET_BANNERS,
            banners,
        });
    };
};

export const fetchBanners = (homepageBanner) => {
    return (dispatch) => {
        dispatch({ type: _FETCH_BANNERS_REQUEST });
        try {
            // In this specific implementation, data is already provided via GetSettings
            // but we wrap it in the lifecycle to satisfy the state machine requirement.
            if (homepageBanner) {
                dispatch({
                    type: _FETCH_BANNERS_SUCCESS,
                    banners: homepageBanner,
                });
            } else {
                // If homepageBanner is not yet available, we stay in Loading or handle appropriately
                // For now, we assume if it's null/undefined, it's still loading or empty
                dispatch({
                    type: _FETCH_BANNERS_SUCCESS,
                    banners: [],
                });
            }
        } catch (error) {
            dispatch({ type: _FETCH_BANNERS_FAILURE, error: error.message });
        }
    };
};

export const bindMember = async (dispatch) => {
    let member = [];
    let balance = 0;

    let responseJson = await ApiEngine.get(ApiUrl._API_GET_MEMBER_DETAILS);

    // if (!responseJson[ApiKey._API_SUCCESS_KEY]) {
    //     dispatch(showResponseMessage(false, responseJson[ApiKey._API_MESSAGE_KEY]));
    //     throw responseJson[ApiKey._API_MESSAGE_KEY];
    // }
    if (responseJson[ApiKey._API_SUCCESS_KEY]) {
        member = responseJson[ApiKey._API_DATA_KEY];


        let walletDetails = {
            currentWalletBalance: 0,
            bonusWalletBalance: 0,
            isPromoCleared: false,
            isBonusWalletRestored: false,
            isValidForPromotion: false,
            isActivedPromoExist: false,
            promoMaxWithdrawal: 0,
            minCoinTarget: 0,
            promotionName: "",
            promoRolloverBalance: 0,
            promoRolloverTarget: 0,
            isFreeGGRPromo: false,
            forceWithdraw: false,
            promoExpiresAt: null,
        }

        let rolloverDetails = member["rolloverDetails"];

        var totalwalletbalance =
            member["primaryCredit"] +
            member["tempPrimaryCredit"];
        var totalbonuswallet =
            member["bonusWallet"] +
            member["tempBonusWallet"];

        balance = isNaN(parseFloat(totalwalletbalance + totalbonuswallet), 3)
            ? "0.00"
            : numberWithCurrencyFormat(parseFloat(totalwalletbalance + totalbonuswallet), 2, true);

        walletDetails = {
            currentWalletBalance: totalwalletbalance,
            bonusWalletBalance: totalbonuswallet,
            isPromoCleared: member["isPromoCleared"],
            isBonusWalletRestored: member["isBonusWalletRestored"],
            isValidForPromotion: member["isAnyTransactionValidForPromo"],
            isActivedPromoExist: member["isActivedPromoExist"],
            promoMaxWithdrawal: member["promoMaxWithdrawal"],
            minCoinTarget: member["minCoinTarget"],
            promotionName: member["promotionName"],
            promoRolloverBalance: member["promoRolloverBalance"],
            promoRolloverTarget: member["promoRolloverTarget"],
            isFreeGGRPromo: member["isFreeGGRPromo"],
            forceWithdraw: member["forceWithdraw"],
            promoExpiresAt: member["promoExpiresAt"] || null,
        }

        dispatch({
            type: _BIND_MEMBER,
            member: member,
            walletBalance: balance, //KT: Should this be totalwalletbalance or member["primaryCredit"] or (totalwalletbalance + totalbonuswallet)?
            walletsDetails: walletDetails,
            rolloverDetails: rolloverDetails
        });
    };
}

export const setProvider = (availableProviders) => {

    const availableList = availableProviders;

    const providerList = groupBy(availableList, item => item.productName.split(' ')[0])

    let providerArray = []
    map(providerList, (item) => {
        if (!stringIsNullOrEmpty(item[0].providerImage)
            || !stringIsNullOrEmpty(item[0].providerImageLight)) {
            providerArray.push({
                providerName: item[0].productName,
                providerImage: item[0].providerImage,
                providerImageLight: item[0].providerImageLight
            })
        }
    })
    
    return (dispatch) => {
        dispatch({
          type: _SET_PROVIDER,
          provider: providerArray,
      });
    };
};

export const bindGames = (games) => {
    return (dispatch) => {
        dispatch({
            type: _BIND_GAMES,
            games,
        });
    };
};

export const bindGamesRecommended = (gamesRecommended) => {
    return (dispatch) => {
        dispatch({
            type: _BIND_GAMES_RECOMMENDED,
            slotGamesCount: gamesRecommended.slotGamesCount,
            slotGames: gamesRecommended.slotGames,
            casinoGamesCount: gamesRecommended.casinoGamesCount,
            casinoGames: gamesRecommended.casinoGames
        });
    };
};

export const bindGamesFeatured = (gamesFeatured) => {
    return (dispatch) => {
        dispatch({
            type: _BIND_GAMES_FEATURED,
            slotGamesCount: gamesFeatured.slotGamesCount,
            slotGames: gamesFeatured.slotGames,

        });
    };
};

export const bindHotGames = (hotGames) => {
    return (dispatch) => {
        dispatch({
            type: _BIND_HOT_GAMES,
            hotGames: hotGames,

        });
    };
};

export const bindHotProviders = (hotProviders) => {
    return (dispatch) => {
        dispatch({
            type: _BIND_HOT_PROVIDERS,
            hotProviders: hotProviders,
        });
    };
};

export const setPaymentList = (payments) => {
    return (dispatch) => {
        dispatch({
            type: _SET_PAYMENT_LIST,
            payments,
        });
    };
};

export const setPageSize = (pagesize) => {
    return (dispatch) => {
        dispatch({
            type: _SET_PAGESIZE,
            data: pagesize,
        });
    };
};

export const setActiveTab = (activeTab) => {
    return (dispatch) => {
        dispatch({
            type: _SET_ACTIVE_TAB,
            data: activeTab,
        });
    };
};

export const setDownlineSearchText = (e) => {
    return async (dispatch) => {
        dispatch({
            type: _DOWNLINE_SEARCH,
            data: e,
        });
    };
};

export const setDownlineQuery = (e) => {
    return async (dispatch) => {
        dispatch({
            type: _DOWNLINE_QUERY,
            data: e,
        });
    };
};

export const setReferralSearchText = (e) => {
    return async (dispatch) => {
        dispatch({
            type: _REFERRAL_SEARCH,
            data: e,
        });
    };
};

export const setReferralQuery = (e) => {
    return async (dispatch) => {
        dispatch({
            type: _REFERRAL_QUERY,
            data: e,
        });
    };
};

export const setGameSearchText = (e) => {
    return async (dispatch) => {
        dispatch({
            type: _GAME_SEARCH,
            data: e,
        });
    };
};

export const setGameQuery = (e) => {
    return async (dispatch) => {
        dispatch({
            type: _GAME_QUERY,
            data: e,
        });
    };
};

export const setWalletInfo = (e) => {
    return async (dispatch) => {
        dispatch({
            type: _SET_WALLET_INFO,
            data: e,
        });
    };
};

export const setOpenMenu = (openMenu) => {
    return async (dispatch) => {
        dispatch({
            type: _SET_OPEN_MENU,
            data: openMenu,
        });
    };
};

export const setReportOverview = ({
    displayData,
    newDisplayData,
    totalTransferToWallet,
    totalTransferToWalletLM,
    totalTransferToMember,
    totalTransferToMemberLM,
    totalBetAmount,
    totalBetAmountLM,
    totalCommission,
    totalCommissionLM,
    totalVipCommission,
    totalBonus,
}) => {
    return async (dispatch) => {
        dispatch({
            type: _SET_REPORT_OVERVIEW,
            displayData,
            newDisplayData,
            totalTransferToWallet,
            totalTransferToWalletLM,
            totalTransferToMember,
            totalTransferToMemberLM,
            totalBetAmount,
            totalBetAmountLM,
            totalCommission,
            totalCommissionLM,
            totalVipCommission,
            totalBonus,
        });
    };
};

export const setDownline = ({ memberData, recentData }) => {
    return async (dispatch) => {
        dispatch({
            type: _SET_DOWNLINE,
            memberData,
            recentData,
        });
    };
};
/// <summary>
/// Author :
/// </summary>
export const setBusy = (iconEnabled, message) => {
    return async (dispatch) => {
        dispatch({
            type: _BUSY,
            message: message,
            iconEnabled: iconEnabled,
        });
    };
};

/// <summary>
/// Author :
/// </summary>
export const setIdle = () => {
    return async (dispatch) => {
        dispatch({
            type: _IDLE,
        });
    };
};


/// <summary>
/// Author :
/// </summary>
export const setPerformApiCall = (status, url) => {
    return async (dispatch) => {
        dispatch({
            type: _API_CALLED,
            data: { success: status, url: url },
        });
    };
};

/// <summary>
/// Author: -
/// </summary>
export const showResponseMessage = (
    status,
    message,
    translateRequired = true
) => {
    return (dispatch) => {
        var messageToShow = message;
        if (translateRequired) {
            messageToShow = formatApiMessage(i18n.t.bind(i18n), message);
        }
        dispatch(
            showMessage({
                type: status ? AlertTypes._SUCCESS : AlertTypes._ERROR,
                content: messageToShow,
            })
        );
    };
};

/// <summary>
/// Author: -
/// </summary>
export const showResponseMessageWithoutT = (
    status,
    message,
    translateRequired = true
) => {
    return (dispatch) => {
        var messageToShow = message;
        dispatch(
            showMessage({
                type: status ? AlertTypes._SUCCESS : AlertTypes._ERROR,
                content: messageToShow,
            })
        );
    };
};

/// <summary>
/// Author: -
/// </summary>
export const showMessage = (alertProps) => {
    return (dispatch) => {

        alertProps.confirmBtnText = alertProps.confirmBtnText ?? i18n.t("OK");
        alertProps.cancelBtnText = alertProps.cancelBtnText ?? i18n.t("CANCEL");

        const customConfirm = alertProps.onConfirm;
        alertProps.onConfirm = async (...args) => {
            disposeMessage()(await dispatch);
            if (customConfirm) {
                customConfirm(...args);
            }
        };

        const customCancel = alertProps.onCancel;
        alertProps.onCancel = async (...args) => {
            disposeMessage()(await dispatch);
            if (customCancel) {
                customCancel(...args);
            }
        };

        alertProps.cancelBtnBsStyle = "danger";
        alertProps.title = alertProps.title ?? "";
        alertProps.allowEscape = false;
        alertProps.reverseButtons = true;

        dispatch({ type: _ALERT_TYPES.SET_ALERT, alert: alertProps });
    };
};

/// <summary>
/// Author: -
/// </summary>
export const disposeMessage = () => {
    return (dispatch) => {
        dispatch({ type: _ALERT_TYPES.NONE });
    };
};

const applyModalPlan = (dispatch, plan, extra = {}) => {
    if (!plan) return;
    dispatch({
        type: _SYNC_MODAL_ORCHESTRATOR,
        modalActive: plan.modalActive,
        modalQueue: plan.modalQueue,
        flags: plan.flags,
        ...extra,
    });
};

let promoteTimerId = null;
let modalInitReady = false;
let modalInitTimerId = null;
/** @type {{ modalId: string, extra: object, dispatch: Function, getState: Function }[]} */
let pendingInitOpens = [];

const cancelScheduledPromote = () => {
    if (promoteTimerId == null) return;
    clearTimeout(promoteTimerId);
    promoteTimerId = null;
};

const flushPendingInitOpens = () => {
    const items = pendingInitOpens.splice(0);
    if (!items.length) return;

    const { dispatch, getState } = items[items.length - 1];
    let orch = readOrchestratorState(getState().appState);

    for (const { modalId, extra } of items) {
        const plan = planOpen(orch, modalId);
        if (!plan) continue;
        orch = { modalActive: plan.modalActive, modalQueue: plan.modalQueue };
        applyModalPlan(dispatch, plan, extra);
    }
};

/**
 * Start the page-init gate. Safe to call multiple times; only the first arms the timer.
 * Call from App componentDidMount so the clock starts at page init.
 */
export const armModalInitGate = (delayMs = MODAL_INIT_DELAY_MS) => {
    if (modalInitReady || modalInitTimerId != null) return;
    modalInitTimerId = setTimeout(() => {
        modalInitTimerId = null;
        modalInitReady = true;
        flushPendingInitOpens();
    }, delayMs);
};

const schedulePromote = (dispatch, getState) => {
    cancelScheduledPromote();
    promoteTimerId = setTimeout(() => {
        promoteTimerId = null;
        const latest = readOrchestratorState(getState().appState);
        if (latest.modalActive) return;
        if (!latest.modalQueue.length) return;
        applyModalPlan(dispatch, planPromote(latest));
    }, MODAL_QUEUE_PROMOTE_DELAY_MS);
};

const requestOrchestratedModal = (modalId, extra = {}) => {
    return (dispatch, getState) => {
        cancelScheduledPromote();
        // Fallback if App forgot to arm — still delay from first open request.
        armModalInitGate();

        if (!modalInitReady) {
            pendingInitOpens = pendingInitOpens.filter((p) => p.modalId !== modalId);
            pendingInitOpens.push({ modalId, extra, dispatch, getState });
            return;
        }

        const orch = readOrchestratorState(getState().appState);
        applyModalPlan(dispatch, planOpen(orch, modalId), extra);
    };
};

const closeOrchestratedModal = (modalId, extra = {}) => {
    return (dispatch, getState) => {
        // Dismiss before init flush so a closed modal never appears.
        pendingInitOpens = pendingInitOpens.filter((p) => p.modalId !== modalId);

        const orch = readOrchestratorState(getState().appState);
        const wasActive = orch.modalActive === modalId;
        // Defer promote so close+open pairs (login→register) don't flash a queued modal,
        // and so the next queued modal waits MODAL_QUEUE_PROMOTE_DELAY_MS.
        applyModalPlan(dispatch, planClose(orch, modalId, { deferPromote: wasActive }), extra);
        if (!wasActive) return;
        schedulePromote(dispatch, getState);
    };
};

/// <summary>
/// Author: -
/// </summary>
export const setDepositModal = (value, tab = 1) => {
    return value
        ? requestOrchestratedModal("deposit", { depositTab: tab })
        : closeOrchestratedModal("deposit");
};

/// <summary>
/// Author: -
/// </summary>
export const setDownlineModal = (value) => {
    return value
        ? requestOrchestratedModal("downline")
        : closeOrchestratedModal("downline");
};

export const setShareReferralModal = (value) => {
    return value
        ? requestOrchestratedModal("shareReferral")
        : closeOrchestratedModal("shareReferral");
};


/// <summary>
/// Author: -
/// </summary>
export const setDepositTab = (tab) => {
    return (dispatch) => {
        dispatch({ type: _SET_DEPOSIT_TAB, depositTab: tab });
    };
};


/// <summary>
/// Author: -
/// </summary>
export const setLoginModal = (value) => {
    return value
        ? requestOrchestratedModal("login")
        : closeOrchestratedModal("login");
};

export const setGameLobbyModal = (value) => {
    return value
        ? requestOrchestratedModal("gameLobby")
        : closeOrchestratedModal("gameLobby");
};

export const setRegisterModal = (value) => {
    return value
        ? requestOrchestratedModal("register")
        : closeOrchestratedModal("register");
};


export const setLatestBets = (value) => {
    return (dispatch) => {
        dispatch({ type: _SET_LATEST_BETS, latestBets: value });
    };
};

export const setResetPassword = (value) => {
    return (dispatch) => {
        dispatch({ type: _SET_RESET_PASSWORD, isResetPassword: value });
    };
};

export const setAppSetting = (
    brandName,
    presetAmt,
    currency,
    medias,
    channels,
    htmlStyle,
    chatSphere,
    quickRegister,
    languages,
    membershipEnabled,
    currencySymbol,
    dialingCodes,
    settingApiComplete,
    promotionLayout,
    promotionShowCategoryTitle,
    showPromoThumbnailClaimButton,
    isPromoBannerTextVisible,
    isReferralBonusActive,
    isReferralRegistrationBonusActive,
    otpEnabled,
    eWalletOTPEnabled,
    captchaEnabled,
    priorityModalTypeId,
    dashboardComponent,
    isNormalDepositEnable,
    isNormalWithdrawalEnable,
    isCryptoWithdrawalEnabled,
    musicPlayerEnabled,
    musicTrackList,
    isEWalletActive,
    isBankTransferActive,
    isReferralCommissionManual,
    isRebateManual,
    availableProductCategories,
    isGameLobbyRequired,
    companyTimeZone,
    bannerAPK,
    homepageBanner,
    //floatingChat,
    isLoginAttemptBlockingEnabled,
    isHotGameEnabled,
    hotGames,
    affiliateLink,
    isCasinoLobbyEnabled,
    isEZUsernameEnabled,
    infoCenterEnabled,
    forceMemberFullname,
    affiliateEnabled,
    affiliateNewTabEnabled,
    isMultiWithdrawalBank,
	maxWithdrawalBankAccounts,
    depositFlow,
    downlineContact,
    isRTPRequired,
    oneWallet,
    availableProviders,
    floatingChat,
    spinWheelSetting,
    dashboardResult,
    infoCenterResult,
    dailyCheckInStatus,
    marqueeResult,
    rewardAdvancedSetting,
    requireBankAccountKYC,
    isRegistrationSuccessCountdownEnabled,
    inactiveDownlineAmount,
    settingVersion,
    isHotProviderEnabled,
    hotProviders,
    playerCounterSetting = [],
    playerCounters = [],
    requireMemberEmailOnWithdrawal,
    showDepositBankBranchCode,
    newGameDurationDays,
    leaderboard = [],
    productHotNewGames = { hotGames: [], newGames: [] },
    fakeTransactionSetting = { settings: [], vipIcons: [] }
) => {
    return (dispatch) => {
        dispatch({
            type: _BIND_SETTING,
            brandName: brandName,
            depositPresetAmt: presetAmt,
            companyCurrency: currency,
            companyIcons: medias,
            channels: channels,
            htmlStyle: htmlStyle,
            chatSphere: chatSphere,
            quickRegister: quickRegister,
            languages: languages,
            membershipEnabled: membershipEnabled,
            currencySymbol: currencySymbol,
            dialingCodes: dialingCodes,
            settingApiComplete: settingApiComplete,
            promotionLayout: promotionLayout,
            promotionShowCategoryTitle: promotionShowCategoryTitle,
            showPromoThumbnailClaimButton: showPromoThumbnailClaimButton,
            isPromoBannerTextVisible: isPromoBannerTextVisible,
            isReferralBonusActive: isReferralBonusActive,
            isReferralRegistrationBonusActive: isReferralRegistrationBonusActive,
            otpEnabled: otpEnabled,
            eWalletOTPEnabled: eWalletOTPEnabled,
            captchaEnabled: captchaEnabled,
            priorityModalTypeId: priorityModalTypeId,
            dashboardComponent: dashboardComponent,
            isNormalDepositEnable: isNormalDepositEnable,
            isNormalWithdrawalEnable: isNormalWithdrawalEnable,
            isCryptoWithdrawalEnabled: isCryptoWithdrawalEnabled,
            musicPlayerEnabled: musicPlayerEnabled,
            musicTrackList: musicTrackList,
            isEWalletActive: isEWalletActive,
            isBankTransferActive: isBankTransferActive,
            isReferralCommissionManual: isReferralCommissionManual,
            isRebateManual: isRebateManual,
            availableProductCategories: availableProductCategories,
            isGameLobbyRequired: isGameLobbyRequired,
            companyTimeZone: companyTimeZone,
            bannerAPK: bannerAPK,
            homepageBanner: homepageBanner,
            isLoginAttemptBlockingEnabled: isLoginAttemptBlockingEnabled,
            isHotGameEnabled: isHotGameEnabled,
            hotGames:hotGames,
            affiliateLink: affiliateLink,
            isCasinoLobbyEnabled: isCasinoLobbyEnabled,
            isEZUsernameEnabled: isEZUsernameEnabled,
            infoCenterEnabled: infoCenterEnabled,
            forceMemberFullname: forceMemberFullname,
            affiliateEnabled: affiliateEnabled,
            affiliateNewTabEnabled: affiliateNewTabEnabled,
            isMultiWithdrawalBank: isMultiWithdrawalBank,
			maxWithdrawalBankAccounts: maxWithdrawalBankAccounts,
            depositFlow: depositFlow,
            downlineContact: downlineContact,
            isRTPRequired: isRTPRequired,
            oneWallet: oneWallet,
            availableProviders: availableProviders,
            floatingChat:floatingChat,
            spinWheelSetting:spinWheelSetting,
            dashboardResult:dashboardResult,
            infoCenterResult:infoCenterResult,
            dailyCheckInStatus:dailyCheckInStatus,
            marqueeResult:marqueeResult,
            rewardAdvancedSetting:rewardAdvancedSetting,
            requireBankAccountKYC:requireBankAccountKYC,
            isRegistrationSuccessCountdownEnabled: isRegistrationSuccessCountdownEnabled,
            inactiveDownlineAmount:inactiveDownlineAmount,
            settingVersion:settingVersion,
            isHotProviderEnabled: isHotProviderEnabled,
            hotProviders: hotProviders,
            playerCounterSetting: playerCounterSetting,
            playerCounters: playerCounters,
            requireMemberEmailOnWithdrawal: requireMemberEmailOnWithdrawal,
            showDepositBankBranchCode: showDepositBankBranchCode,
            newGameDurationDays: newGameDurationDays,
            leaderboard: leaderboard,
            productHotNewGames: productHotNewGames,
            fakeTransactionSetting: fakeTransactionSetting,
        });
    };
};

export const setBusyLoading = (value) => {
    return async (dispatch) => {
        dispatch({
            type: _BUSY_LOADING,
            isBusyLoading: value
        });
    };
};

export const setMyProfileModal = (value) => {
    return value
        ? requestOrchestratedModal("profile")
        : closeOrchestratedModal("profile");
};

export const setSpinWheelListModal = (value) => {
    return value
        ? requestOrchestratedModal("spinWheelList")
        : closeOrchestratedModal("spinWheelList");
};

export const setSpinWheelReportModal = (value) => {
    return value
        ? requestOrchestratedModal("spinWheelReport")
        : closeOrchestratedModal("spinWheelReport");
};

export const setSeoContent = ({
    pageName,
    seoTitle,
    seoDescription,
    seoKeywords,
}) => {
    return async (dispatch) => {
        dispatch({
            type: _SET_SEO_CONTENT,
            pageName,
            seoTitle,
            seoDescription,
            seoKeywords,
        });
    };
};

export const setReportOverviewModal = (value) => {
    return value
        ? requestOrchestratedModal("reportOverview")
        : closeOrchestratedModal("reportOverview");
};
export const setGameIframeModal = (value) => {
    return value
        ? requestOrchestratedModal("gameIframe")
        : closeOrchestratedModal("gameIframe");
};

export const setCompleteInfoModal = (value) => {
    return value
        ? requestOrchestratedModal("completeInfo")
        : closeOrchestratedModal("completeInfo");
};

export const setRegisterSuccessModal = (value) => {
    return value
        ? requestOrchestratedModal("registerSuccess")
        : closeOrchestratedModal("registerSuccess");
};

export const setShowAnnouncementModal = (value) => {
    return value
        ? requestOrchestratedModal("announcement")
        : closeOrchestratedModal("announcement");
};

export const setDailyCheckinModal = (value) => {
    return value
        ? requestOrchestratedModal("dailyCheckin")
        : closeOrchestratedModal("dailyCheckin");
};

export const setDailyCheckInExist = (value) => {
    return (dispatch) => {
        dispatch({ type: _SET_DAILY_CHECKIN_EXIST, dailyCheckInExist: value });
    };
};


export const setReferralBonusModal = (value) => {
    return value
        ? requestOrchestratedModal("referralBonus")
        : closeOrchestratedModal("referralBonus");
};

export const setMusicPlayerModal = (value) => {
    return value
        ? requestOrchestratedModal("musicPlayer")
        : closeOrchestratedModal("musicPlayer");
};

export const setSpinWheelLoaded = (value) => {
    return (dispatch) => {
        dispatch({ type: _SET_SPIN_WHEEL_LOADED, spinWheelLoaded: value });
    };
};

export const userKeepLogin = (isKeepedLogin) => {
    return (dispatch) => {
        dispatch({
            type: _IS_KEEPED_LOGIN,
            data: isKeepedLogin,
        });
    };
};

export const setLanguageModal = (value) => {
    return value
        ? requestOrchestratedModal("language")
        : closeOrchestratedModal("language");
};

export const setDailyCheckInDetails = (value) => {
    return (dispatch) => {
        dispatch({ type: _SET_DAILY_CHECK_IN_DETAILS, dailyCheckInDetails: value });
    };
};

export const setRewardType = (value,name) => {
    return (dispatch) => {
        dispatch({ type: _SET_REWARD_TYPE, rewardType: {id:value,name:name} });
    };
};

export const setGameProvider = (value) => {
    return (dispatch) => {
        dispatch({ type: _SET_GAME_PROVIDER, gameProviderId: value });
    };
};